// extracted by mini-css-extract-plugin
export default {"wrapper":"Projects_wrapper__VMD5k","container":"Projects_container__MaVS7"};